import type { fabric } from 'fabric';
import { isObjectLocked } from '@/lib/layerOps';

function targets(canvas: fabric.Canvas): fabric.Object[] {
  return canvas.getActiveObjects().filter((obj) => !isObjectLocked(obj));
}

export function flipSelection(
  canvas: fabric.Canvas,
  axis: 'x' | 'y'
): boolean {
  const objects = targets(canvas);
  if (!objects.length) return false;

  objects.forEach((obj) => {
    if (axis === 'x') {
      obj.set('flipX', !obj.flipX);
    } else {
      obj.set('flipY', !obj.flipY);
    }
    obj.setCoords();
  });

  const active = canvas.getActiveObject();
  if (active) active.setCoords();
  canvas.requestRenderAll();
  return true;
}

export function rotateSelection(
  canvas: fabric.Canvas,
  degrees: number
): boolean {
  const objects = targets(canvas);
  if (!objects.length) return false;

  objects.forEach((obj) => {
    const next = ((((obj.angle || 0) + degrees) % 360) + 360) % 360;
    obj.rotate(next);
    obj.setCoords();
  });

  const active = canvas.getActiveObject();
  if (active) active.setCoords();
  canvas.requestRenderAll();
  return true;
}
